import React from "react";
import { AppShell, Burger, Tooltip, Group, Image, Button, Text } from "@mantine/core";
import logoUrl from "../assets/logo.svg";

import SpotlightDocusaurus from "#root/components/Spotlight/SpotlightDocusaurus";
import ColorSchemeToggle from "#root/components/ColorSchemeToggle/ColorSchemeToggle";

const HeaderContent = ({ opened, toggle }: { opened: boolean; toggle: () => void }) => (
  <AppShell.Header>
    <Group h="100%" px="md" justify="space-between">
      <Group>
        <Burger opened={opened} onClick={toggle} size="sm" aria-label="menu" />
        <Tooltip label="Go to the landing page">
          <Button
            autoContrast
            color="gray"
            variant="transparent"
            size="sm"
            aria-label="Go to the landing page"
            component="a"
            href="/"
          >
            <Image h={50} fit="contain" src={logoUrl} alt="logo" />
            <Text tt="capitalize" fw={700}>
              a11yStart
            </Text>
          </Button>
        </Tooltip>
      </Group>
      <Group>
        <SpotlightDocusaurus />
        <ColorSchemeToggle />
      </Group>
    </Group>
  </AppShell.Header>
);

export default HeaderContent;
